import { z } from 'zod'

export const applicantSearchSchema = z.object({
  view: z.enum(['details', 'applications', 'emails', 'interviews', 'files', 'notes']).default('details'),
})

export type ApplicantSearch = z.infer<typeof applicantSearchSchema>
